import type { EventsInfoTabState } from './reducer';
import { compose } from 'redux';

import type { AppState } from '../AppState';

export const selectEventsTabDomain = (state: AppState): EventsInfoTabState => state.eventsInfoTab;

export const selectEventsWebData = compose((domainState: EventsInfoTabState) => domainState.eventsWebData, selectEventsTabDomain);

export const selectEventsReportWebData = compose((domainState: EventsInfoTabState) => domainState.reportWebData, selectEventsTabDomain);
